import React from 'react'
import { TabPanel, PanelContainer } from '~/components/shared/TabNav'
import TodaysActions from './TodaysActions'
import UpcomingMeetings from './UpcomingMeetings'
import TasksDue from './TasksDue'
import PastDueTasks from './PastDueTasks'

const TabNavPanelContainer = () => {
  return (
    <PanelContainer asChild>
      <div>
        <TabPanel name="prioritized_tasks" asChild>
          <TodaysActions />
        </TabPanel>
        <TabPanel name="upcoming_meetings" asChild>
          <UpcomingMeetings />
        </TabPanel>
        <TabPanel name="tasks_due" asChild>
          <TasksDue />
        </TabPanel>
        <TabPanel name="past_due_tasks" asChild>
          <PastDueTasks />
        </TabPanel>
        <div className="min-w-[472px] overflow-hidden"></div>
      </div>
    </PanelContainer>
  )
}
export default TabNavPanelContainer
